export default {
    //德语
    DiagnosticReport:'Diagnose berichte',
    troubleCode:'Fehlercode',
    time:'Zeit',
    noTItle:'Kontrolle des Herstellers',
    TestReport:'Testbericht',
    VehicleInformation:'Fahrzeuginformationen',
    DataStream:'Datenstrom',
    IMReadiness:'I/M-Bereitschaft',
    Communication:'Kommunikationsprotokoll',
    notFaultCode:'Fehlerfreier Code',
    nodataflow:'Keine ungewöhnlichen Datenströme',
    PositioningPrompt:'Aktivieren Sie die Standortfunktion, um lokale Preise zu erhalten',
    FaultCode:'Fehlercode',
    AIDiagnosis:'AI-Diagnose',
    AIWait:'KI-Bericht oder automatische Diagnose warten',
    FailedFaultCode:'Fehlercodeinformationen können nicht abgerufen werden',
    AIError:'AI-Analyse fehlgeschlagen',
    more:'mehr',
    StoredCodes:'Stored Codes',
    PendingCodes:'Pending Codes',
    PermanentCodes:'Permanent Codes',
    ManufacturerControl:'Kontrolle des Herstellers',
    continue:'fortsetzen',
    // 引导定位
    notlimits:'Positionsberechtigung kann nicht abgerufen werden',
    setupSteps:'Einrichtungsschritte:',
    openset:'Öffnen Sie die "Einstellungen"-App',
    findSet:'Finden Sie die von Ihnen verwendete App',
    clickset:'Klicken Sie auf "Position"',
    selectLimits:'"Während der Nutzung" oder "Immer" auswählen',
    blackRefresh:'Zurück zur App und Seite aktualisieren',
    openAppSet:'Klicken Sie auf "App-Verwaltung" oder "Apps"',
    findUseBrowser:'Den von Ihnen verwendeten Browser finden',
    clickAuthority:'Klicken Sie auf "Berechtigungsverwaltung"',
    findejurisd:'"Standort"-Berechtigung finden',
    selectjurisd:'Auswahl erlauben oder beim Gebrauch erlauben',
    phoneJurisd:'Überprüfen Sie die Standortberechtigungen der Handy-App:',
    openJurisd:'"Standort"-Erlaubnis aktivieren',
    report:'Bericht',
    AI:'KI',
    Freeze:'Frame einfrieren',
    VoltageInfo:'Spannungsinformation',
    Voltage:'Spannung'
}